import React from 'react'
import close from '../../assets/images/close.svg'

function ClosePlayer() {
  
  function closePlayer() {
    document.getElementById(`footer-copyright`).style.display = `flex`
    document.getElementById(`audio-player-container`).removeAttribute(`style`)
    document.getElementById(`audio-player`).removeAttribute(`style`)
    document.getElementById(`audio-player-container`).style.display = `none`
    document.getElementById(`audio-player`).style.display = `none`
    document.getElementById(`player-source`).pause()
    document.getElementById(`player-source`).currentTime = 0
    document.getElementById(`player-collapse`).style.display = `none`
    document.getElementById(`player-expand`).style.display = `block`
    document.getElementById(`audio-player-container`).removeAttribute(`class`)
    document.getElementById(`audio-player`).removeAttribute(`class`)
    document.getElementById(`song-backward`).removeAttribute(`class`)
    document.getElementById(`song-forward`).removeAttribute(`class`)
    document.getElementById(`song-cover`).removeAttribute(`class`)
    document.getElementById(`song-title`).removeAttribute(`class`)
  }
  
  return (
    <button id={`close-player`} onClick={closePlayer} style={{maskImage: `url(${close})`, WebkitMaskImage: `url(${close})`}}>Close Player</button>
  )
}

export default ClosePlayer